import React, { useState } from 'react';
import './AddBrandModal.styles.css';
import apiService from '../../services/api';

const AddBrandModal = ({ isOpen, onClose, onSave }) => {
    const [brandName, setBrandName] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [useForRepair, setUseForRepair] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [apiError, setApiError] = useState(null);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!brandName.trim()) {
            alert('Brand name is required');
            return;
        }

        setIsSaving(true);
        setApiError(null);

        try {
            const res = await apiService.createBrand({
                name: brandName.trim(),
                description: shortDescription.trim(),
                use_for_repair: useForRepair
            });

            const createdBrand = res.data || res;

            // Pass the new brand object back to parent so it can update dropdown lists
            if (onSave) {
                onSave(createdBrand);
            }

            // Reset and close
            setBrandName('');
            setShortDescription('');
            setUseForRepair(false);
            setApiError(null);
            onClose();
        } catch (err) {
            setApiError('Failed to create brand: ' + err.message);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" style={{ maxWidth: '540px', width: '95%', borderRadius: '12px', overflow: 'visible', background: 'var(--etpos-card, #fff)', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }} onClick={(e) => e.stopPropagation()}>
                <div className="modal-header" style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text, #1e293b)' }}>Add Brand</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: '1.25rem', lineHeight: 1, padding: '0.25rem' }}>✕</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ padding: '1.5rem 1.5rem' }}>
                        {apiError && (
                            <div style={{
                                marginBottom: '1rem',
                                padding: '0.6rem 0.9rem',
                                background: '#fef2f2',
                                border: '1px solid #fecaca',
                                borderRadius: '6px',
                                color: '#991b1b',
                                fontSize: '0.85rem'
                            }}>
                                {apiError}
                            </div>
                        )}

                        <div style={{ marginBottom: '1.25rem' }}>
                            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>
                              Brand Name <span style={{ color: '#ef4444' }}>*</span>
                            </label>
                            <input
                                type="text"
                                value={brandName}
                                onChange={(e) => setBrandName(e.target.value)}
                                placeholder="Brand name"
                                required
                                style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none' }}
                                autoFocus
                            />
                        </div>

                        <div style={{ marginBottom: '1.25rem' }}>
                            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', color: 'var(--etpos-text-muted, #374151)', marginBottom: '0.4rem' }}>
                              Short Description
                            </label>
                            <input
                                type="text"
                                value={shortDescription}
                                onChange={(e) => setShortDescription(e.target.value)}
                                placeholder="Short description (optional)"
                                style={{ width: '100%', padding: '0.65rem 0.85rem', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.875rem', boxSizing: 'border-box', outline: 'none' }}
                            />
                        </div>

                        <div style={{ marginBottom: 0 }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', cursor: 'pointer', fontSize: '0.875rem', color: 'var(--etpos-text, #374151)', fontWeight: '500' }}>
                                <input
                                    type="checkbox"
                                    checked={useForRepair}
                                    onChange={(e) => setUseForRepair(e.target.checked)}
                                    style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#3b82f6' }}
                                />
                                Use for repair? <i className="fa fa-info-circle" style={{ color: '#0ea5e9' }}></i>
                            </label>
                        </div>
                    </div>

                    <div style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid #e2e8f0', background: '#f8fafc', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', alignItems: 'center' }}>
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={isSaving}
                            style={{ padding: '0.6rem 1.5rem', background: 'var(--etpos-card, #fff)', color: '#64748b', border: '1px solid #cbd5e1', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '0.875rem' }}
                        >
                            Close
                        </button>
                        <button
                            type="submit"
                            disabled={isSaving}
                            style={{ padding: '0.6rem 1.75rem', background: isSaving ? '#93c5fd' : '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: isSaving ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '0.875rem', boxShadow: '0 2px 4px rgba(59,130,246,0.3)', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
                        >
                            {isSaving ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddBrandModal;
